import { List, Map, fromJS } from 'immutable';

export function request(state, { id }) {
    let opened = state.get('opened') || Map();

    if (opened.contains(id)) {
        opened = opened.filter(o => o !== id);
    }

    state = state.set('opened', opened);

    return state;
}